import React, {Component} from 'react';
import DisplayBox from '../DisplayBox';
// import EmailModal from '../../../Email/EmailModal';
// import BottomButtons from './BottomButtons';
import styles from '../Calculator.scss';
import axios from 'axios';

import night from "../icons/nightlife.png";
import golf from "../icons/golf.png";
import date from "../icons/datenight.png";
import movie from "../icons/movie.png";
import roadtrips from "../icons/roadtrips.png";
import sleep from "../icons/sleep.jpg";

export default class TimeSaved extends Component {

  constructor(props) {
    super(props);
    this.state = {
      coupon_data: undefined,
      night: [],
      sleep: [],
      golf: [],
      date: [],
      movie: [],
      islands: [],

      loading: true
    }

  }

  componentDidMount () {
    axios.defaults.headers.common["Authorization"] = localStorage.getItem(
      "jwt"
    );
    // axios
      // .get("/api/admin/getallcoupons")
      // .then(res => {
      //   this.setState({
      //     coupon_data: res.data
      //   }, () => {this.matchCoupons()});
      // })
      // .catch(e => console.log(e));
  };

  matchCoupons = () => {
    let couponList = this.state.coupon_data;
    couponList.forEach((coupon => {
      let type = coupon.coupon_type;
      switch (type) {
        case "night":
          this.setState({night: this.state.night.push(coupon)})
          break;
        case "sleep":
          this.setState({sleep: this.state.sleep.push(coupon)})
          break;
        case "golf":
          this.setState({golf: this.state.golf.push(coupon)})
          break;
        case "date":
          this.setState({date: this.state.date.push(coupon)})
          break;
        case "movie":
          this.setState({movie: this.state.movie.push(coupon)})
          break;
        case "islands":
          this.setState({islands: this.state.islands.push(coupon)})
          break;
        default:
          break;
      }
    }));
  }

  render() {

    return(
      <div className={styles.section}>
        <h3 style={{color: 'black', margin: '0'}}>With <span className={styles.highlight}> {this.props.commute} extra hours per month in Kingston </span>
          you could...
        </h3>
        <div className="row mt-4">

          <div className="col-sm-4 px-0">
            <DisplayBox
              image={night}
              coupon={this.state.night}
              text={
                <h5>
                  Spend{" "}
                  <span className={styles.highlight}>
                    {Math.round(this.props.commute / 3)} nights
                  </span>{" "}
                  on the town
                </h5>
              }
            />
          </div>
          <div className="col-sm-4 px-0">
            <DisplayBox
              image={sleep}
              coupon={this.state.sleep}
              text={
                <h5>
                  Average an additional{" "}
                  <span className={styles.highlight}>
                    {(this.props.commute * 60) / 30} minutes
                  </span>{" "}
                  of rest each day
                </h5>
              }

            />
          </div>
          <div className="col-sm-4 px-0">
            <DisplayBox
              image={golf}
              coupon={this.state.golf}
              text={
                <h5>
                  Play{" "}
                  <span className={styles.highlight}>
                    {Math.round(this.props.commute / 5)}{" "}
                    rounds
                  </span>{" "}
                  of golf
                </h5>
              }
            />
          </div>
          <div className="col-sm-4 px-0">
            <DisplayBox
              image={date}
              coupon={this.state.date}
              text={
                <h5>
                  Go on{" "}
                  <span className={styles.highlight}>
                    {Math.round(this.props.commute / 3)} date
                    nights
                  </span>{" "}
                </h5>
              }
            />
          </div >
          <div className="col-sm-4 px-0">
            <DisplayBox
              image={movie}
              coupon={this.state.movie}
              text={
                <h5>
                  Watch{" "}
                  <span className={styles.highlight}>
                    {Math.round(this.props.commute / 2)} movies
                  </span>{" "}
                </h5>
              }
            />
          </div>
          <div className="col-sm-4 px-0">
            <DisplayBox
              image={roadtrips}
              coupon={this.state.islands}
              text={
                <h5>
                  Take {" "}
                  <span className={styles.highlight}>
                    {Math.round(this.props.commute / 5)}{" "}
                    road-trips
                  </span>{" "}
                  to explore the 1000 Islands{" "}
                </h5>
              }
            />
          </div>
        </div>
        {/*<BottomButtons />*/}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Calculator/sections/TimeSaved.js